const PREFIX = "ovis-ctf";

export const prefixActionName = (module, actionName) =>
  `${PREFIX}/${module}/${actionName}`;

export const fulfilled = (actionName) => `${actionName}_FULFILLED`;
export const pending = (actionName) => `${actionName}_PENDING`;
export const rejected = (actionName) => `${actionName}_REJECTED`;
